import React from 'react';
import { motion } from 'framer-motion';
import { MessageCircle } from 'lucide-react';

const WhatsAppButton: React.FC = () => {
    const handleClick = () => {
        const phone = "5511999999999"; // TODO: Substituir pelo numero real
        const text = encodeURIComponent("Ola! Gostaria de saber mais sobre o Garcom Digital.");
        window.open(`https://wa.me/${phone}?text=${text}`, '_blank');
    };

    return (
        <motion.button
            initial={{ scale: 0, opacity: 0 }}
            animate={{ scale: 1, opacity: 1 }}
            whileHover={{ scale: 1.1 }}
            whileTap={{ scale: 0.9 }}
            onClick={handleClick}
            className="fixed bottom-6 right-6 z-[150] bg-emerald-500 hover:bg-emerald-600 text-white p-5 rounded-full shadow-[0_10px_40px_rgba(16,185,129,0.3)] flex items-center gap-3 group transition-all"
        >
            <span className="max-w-0 overflow-hidden group-hover:max-w-xs whitespace-nowrap transition-all duration-500 font-bold text-sm tracking-tight">
                Falar com Vendas
            </span>
            <MessageCircle size={24} />
        </motion.button>
    );
};

export default WhatsAppButton;
